// Add your feature-specific hooks here
import { useSmartQuery } from '@shared/api/queries/hooks';
import { QueryKeyFactory } from '@shared/api/queries/queryKeyFactory';
import { mxApi } from './api';

export const useMxDashboard = (remoteUtilityId: string) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.summary(),
    () => mxApi.getMeterSummaryDashboard(remoteUtilityId),
    {
      enabled: !!remoteUtilityId, // avoid unnecessary call if undefined
      refetchOnWindowFocus: true,
    }
  );
};

export const useSearchMeters = ({
  searchField,
  searchData,
  remoteUtilityId,
}: {
  searchField: string;
  searchData: string;
  remoteUtilityId: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.search.meters(searchField, searchData),
    () => mxApi.searchMeters({ searchField, searchData, remoteUtilityId }),
    {
      enabled: !!searchData && !!remoteUtilityId,
      refetchOnWindowFocus: true,
    }
  );
};

export const useDeviceDetail = ({
  meterId,
  remoteUtilityId,
}: {
  meterId: number;
  remoteUtilityId: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.device.detail(meterId),
    () => mxApi.getDeviceDetail({ meterId, remoteUtilityId }),
    {
      enabled: !!meterId && !!remoteUtilityId,
      refetchOnWindowFocus: true,
    }
  );
};

export const useValidationDashboard = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.validationDashboard(params),
    () => mxApi.getValidationDashboard(params),
   
  );
};

export const useRunWiseReadingValidationDashboard = (params: { 
  remote_utility_id: any;
  meter_run_id: string;
}) => {
  const isEnabled = !!params.meter_run_id;

  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.runWiseReadingValidationDashboard(params),
    () => mxApi.getRunWiseReadingValidationDashboard(params),
    {
      enabled: isEnabled, // ✅ will not fetch unless meter_run_id is truthy
    }
  );
};


export const useMeterConditionDashboard = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.meterConditionDashboard(params),
    () => mxApi.getMeterConditionDashboard(params),
    
  );
};

export const useReadCycleValidationStats = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.readCycleValidationStats(params),
    () => mxApi.getReadCycleValidationStats(params),
    
  );
};

export const useValidationIssues = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.validationIssues(params),
    () => mxApi.getValidationIssues(params),
   
  );
};

export const useDailyValidationTrend = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.dailyValidationTrend(params),
    () => mxApi.getDailyValidationTrend(params),
   
  );
};

export const useValidationStats = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.validationStats(params),
    () => mxApi.getValidationStats(params),
    
  );
};

export const useMeterRunList = (params: { 
  remote_utility_id: any;
  page?: number;
  exclude_run_status?: string;
  month_year?: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.dashboard.meterRunList(params),
    () => mxApi.getMeterRunList(params),
   
  );
};